const mainPreview = {
  mainPreview: {
    search: "Search",
  },
};

export { mainPreview };
